import react from "react";
import reactDOM from "react-dom";
import * as reactSpringWeb from "@react-spring/web";
import classnames from "classnames";
import dayjs from "dayjs";
import * as mobxReact from "mobx-react";
import * as akuLcRenderer from "@al/aku-lc-renderer";
import * as akuLcCore from "@al/aku-lc-core";
import * as reactSplide from "@splidejs/react-splide";
import * as RcUtil from "@al/rc-util";
import Mask from "@al/rc-mask";
import LazyImage from "@al/rc-lazy-image";
import "@al/rc-lazy-image/lib/index.css";
import "@al/rc-mask/lib/index.css";

export const resolve = {
  react,
  classnames,
  "react-dom": reactDOM,
  "@al/rc-mask": Mask,
  "@al/rc-util": RcUtil,
  "@react-spring/web": reactSpringWeb,
  "mobx-react": mobxReact,
  "@al/aku-lc-renderer": akuLcRenderer,
  "@al/aku-lc-core": akuLcCore,
  "@splidejs/react-splide": reactSplide,
  dayjs,
  "@al/rc-lazy-image": LazyImage,
  "@al/rc-lazy-image/lib/index.css": undefined,
  "@al/rc-mask/lib/index.css": undefined,
};
